import ApplySteps from 'components/templates/Apply/ApplySteps';
export default ApplySteps;
